import React, { useEffect, useContext, useState } from 'react'
import { Input as InputString } from 'antd'
import _ from 'lodash'
import { SiteContext } from '../../contextProviders/siteContextProvider'
import { useDebounce } from 'react-use'
import { RolodexPatchBatch } from '../../util/RolodexInterface'
import { useAuthInfo } from '../../contextProviders/useAuthInfo'

interface EditableStringElementProps {
  value: string | undefined
  objectId: string
  field: string
  refetchData?: () => void
  rolodexType: string
  debounceTime?: number
  style?: React.CSSProperties
}

export const EditableStringElement: React.FC<EditableStringElementProps> = ({
  value,
  objectId,
  field,
  refetchData,
  rolodexType,
  debounceTime,
  style,
}) => {
  const siteData = useContext(SiteContext)
  const auth0 = useAuthInfo()
  const [editedValue, setEditedValue] = useState<string | undefined>(value)

  useEffect(() => {
    setEditedValue(value)
  }, [value])

  useDebounce(
    () => {
      if (editedValue !== value && siteData) {
        //only worth patching when they're different
        const patchBody = {
          id: objectId,
          type: rolodexType,
          data: {
            [field]: editedValue ?? null,
          },
          tags: {
            site: siteData.siteSlug,
            organization: siteData.orgSlug,
          },
        }
        RolodexPatchBatch([patchBody], auth0, siteData).then((d) => {
          refetchData?.()
        })
      }
    },
    debounceTime ?? 500,
    [editedValue]
  )

  return (
    <InputString
      style={style}
      key={objectId}
      defaultValue={value}
      value={editedValue}
      onChange={(e) => {
        setEditedValue(e.target.value)
      }}
    />
  )
}
